import { Link, useLocation } from 'react-router-dom';
import Icon from './Icon';

// "Send feedback" in the shells' top bars: opens /feedback with the page
// it came from as ?from=, which the form sends as `where`. Hidden on the
// feedback page itself. Compact = the round icon button next to the
// theme toggle (TripShell's bar is full); otherwise icon + words.
export default function FeedbackLink({ compact = false }: { compact?: boolean }) {
  const location = useLocation();
  if (location.pathname === '/feedback') return null;
  const to = `/feedback?from=${encodeURIComponent(location.pathname + location.search)}`;
  return (
    <Link
      to={to}
      aria-label="Send feedback"
      title="Send feedback"
      className={`wa-focusable${compact ? '' : ' fb-link'}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 7,
        height: 32,
        width: compact ? 32 : undefined,
        padding: compact ? 0 : '0 12px',
        borderRadius: 'var(--r-pill)',
        border: '1px solid var(--line)',
        color: 'var(--ink-soft)',
        fontFamily: 'var(--font-ui)',
        fontSize: 13,
        textDecoration: 'none',
        whiteSpace: 'nowrap',
        flexShrink: 0,
      }}
    >
      <Icon name="message" size={15} />
      {!compact && <span className="fb-words">Send feedback</span>}
    </Link>
  );
}
